import type { DataDownloadCanvasContent } from '@factorialco/f0-react'

import { defineCanvasEntity } from 'modules/ai/copilotActions/canvas/defineCanvasEntity'

import { DataDownloadContent } from 'modules/ai/copilotActions/canvas/dataDownload/components/DataDownloadContent'
import { DataDownloadHeader } from 'modules/ai/copilotActions/canvas/dataDownload/components/DataDownloadHeader'
import { DataDownloadProvider } from 'modules/ai/copilotActions/canvas/dataDownload/components/DataDownloadProvider'

/**
 * Canvas renderer for `{ type: "dataDownload" }` content. The provider
 * tracks view state so the header (export buttons) and content (table)
 * share it.
 */
export const dataDownloadCanvasEntity = defineCanvasEntity<DataDownloadCanvasContent>({
  type: 'dataDownload',
  renderContent: ({ content, refreshKey }) => (
    <DataDownloadContent content={content} refreshKey={refreshKey} />
  ),
  renderHeader: ({ content, onClose }) => (
    <DataDownloadHeader content={content} onClose={onClose} />
  ),
  wrapper: ({ content, children }) => (
    <DataDownloadProvider content={content}>{children}</DataDownloadProvider>
  ),
})
